import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  const isHome = location.pathname === '/';
  const isTransparent = isHome && !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className={`text-xl md:text-2xl font-heading font-semibold whitespace-nowrap transition-colors duration-300 ${
              isTransparent ? 'text-white' : 'text-foreground-900'
            }`}
          >
            她之间
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                isTransparent
                  ? 'text-white/90 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-600'
              } ${location.pathname === '/' ? (isTransparent ? 'text-white' : 'text-primary-600') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/qinggan-gushi"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                isTransparent
                  ? 'text-white/90 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-600'
              } ${location.pathname.includes('/category/') ? (isTransparent ? 'text-white' : 'text-primary-600') : ''}`}
            >
              文章分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                isTransparent
                  ? 'text-white/90 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-600'
              } ${location.pathname === '/about' ? (isTransparent ? 'text-white' : 'text-primary-600') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
              isTransparent ? 'text-white' : 'text-foreground-800'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap ${
                location.pathname === '/' ? 'text-primary-600 bg-primary-50' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/qinggan-gushi"
              className={`text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap ${
                location.pathname.includes('/category/') ? 'text-primary-600 bg-primary-50' : 'text-foreground-700'
              }`}
            >
              文章分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap ${
                location.pathname === '/about' ? 'text-primary-600 bg-primary-50' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}